import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { skipOpen } from "../../redux/reducers/companySkip";
import { fySettingsOpen } from "../../redux/reducers/fySettings";
import { resetState } from "../../redux/reducers/FYSetupStep";
import { setRemoveFY } from "../../redux/reducers/UserPreference";
import { showErrorSnackbar, showSuccessSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import { deleteFinancialYear } from "../../graphql";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteFY = ({ open, setOpen, entryInd, entryRows, setEntryRows }) => {
  const { theme } = useThemes()

  const createNewFyDta = useSelector((state) => state?.newFyStepsReducer);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };





  async function deleteItem() {
    try {
      setLoading(true);
      const res = await API.graphql(
        graphqlOperation(deleteFinancialYear, { financialyearid: entryInd })
      );
      if (entryRows.length) {
        let arr = entryRows.filter((item, ind) => {
          if (ind != entryInd) {
            return item;
          }
        });
        setEntryRows(arr);
      }
      setOpen(false);
      setLoading(false);
      dispatch(setRemoveFY(entryInd));
      showSuccessSnackbar("Financial Year deleted successfully");
      dispatch(fySettingsOpen());
    } catch (error) {
      setOpen(false);
      setLoading(false);
      showErrorSnackbar("something went wrong. Please wait a moment and try again.")
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? "#FFF1E6"
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to delete this Financial Year?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteFY;
